import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';


import { TestService } from '../test.service';
import { Profile } from 'selenium-webdriver/firefox';
import { PlayerPosition } from '../models/player.model';
import { FormBuilder, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-select-profile-dialog',
    templateUrl: './select-profile-dialog.component.html',
    styleUrls: ['./select-profile-dialog.component.css'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatDialogActions, MatButton]
})
export class SelectProfileDialogComponent implements OnInit {
  
  _profiles: Profile[];
  _positions: PlayerPosition[];
  _teamId: string;


  profileId: string;
  PlayerPositionId: string;

  constructor(
    public dialogRef: MatDialogRef<SelectProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public message,
  
    public _testService: TestService) { 
        
        this._teamId = message.teamid;
    }


  ngOnInit(): void {
  
  
    

    //Get profiles
    this._testService.getAllProfiles().subscribe((p : Profile[])=> {
      this._profiles = p;
      this._testService.GetAllPositions(this._teamId).subscribe((pos: PlayerPosition[])=>{
          this._positions = pos;
      });
      //console.log(p);
    })
  }

  onCloseConfirm() {
    this.dialogRef.close({
       profileId: this.profileId ,
       PlayerPositionId: this.PlayerPositionId 
       
    });
   
  }

    onNoClick(): void {
      //console.log(this.profileId);
     this.dialogRef.close();
    }

}
